import { useEditColorCollections } from "../../edit-color-collections";
import { useEditColorCollectionsStore } from "../../../js/stores/edit-color-collections-store";
import { SharedIcon } from "../shared/shared-icon";

export function EditColorCollectionsButton() {
  const { collectionId } = useEditColorCollections();
  const openExistingCollectionFromModal = useEditColorCollectionsStore(
    (state) => state.openExistingCollectionFromModal
  );

  return (
    <button
      className="edit-color-collection-button"
      type="button"
      onClick={() => openExistingCollectionFromModal(collectionId)}
    >
      <SharedIcon iconName="#sprite-edit" />
    </button>
  );
}
